import { ELEMENT_LI, ELEMENT_LIC, ELEMENT_OL, ELEMENT_UL } from "@udecode/plate-list";
import { ELEMENT_PARAGRAPH } from "@udecode/plate-paragraph";

export class ElementFactory {
  static createParagraph(text: string) {
    return { type: ELEMENT_PARAGRAPH, children: [{ text }] };
  }

  static createOrderedList(items: string[]): any {
    return ElementFactory.createList(ELEMENT_OL, items);
  }

  static createUnorderedList(items: string[]): any {
    return ElementFactory.createList(ELEMENT_UL, items);
  }

  static createList(type: typeof ELEMENT_OL | typeof ELEMENT_UL, items: string[]): any {
    return {
      type,
      children: items.map((text) => ({
        type: ELEMENT_LI,
        children: [{ type: ELEMENT_LIC, children: [{ text }] }],
      })),
    };
  }
}
